<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">

        <div class="row marges">

            <div class="col y_items_center">
                <h1 class="title">{{ 'tender.read.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour à la liste des appels d'offres -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ ('tender.list.back' + (userService.hasOneOfThisRoles(currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']) ? '' : '.self') + '.value') | translate }}
                </button>

                @if(updateAllowed) {

                    <!-- Soumission -->

                    <button class="btn_cta btn_little" type="submit">
                        {{  submitLabel }}
                    </button>
                }

            </div>

        </div>

    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group #tabGroup>
        <mat-tab [label]="'generalData.value' | translate" data-tag="generalData">
            <ng-container *ngTemplateOutlet="generalData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'tender.data.plural.value' | translate" data-tag="tenderData">
            <ng-container *ngTemplateOutlet="tenderData"></ng-container>
        </mat-tab>
        @if((userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine) && form.get('offerCreatorStatus').value === 'reply') {
            <mat-tab [label]="'offer.list.selection.value' | translate" data-tag="offersSelection">
                <ng-container *ngTemplateOutlet="offersSelection"></ng-container>
            </mat-tab>
        }
        @if(isMine) {
            <mat-tab [label]="'offerCreator.plural.selection.value' | translate" data-tag="offerCreatorsSelection">
                <ng-container *ngTemplateOutlet="offerCreatorsSelection"></ng-container>
            </mat-tab>
        }
        @if(isMine || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) {
            <mat-tab [label]="'offerCreator.plural.response.plural.value' | translate" data-tag="offerCreatorsResponse">
                <ng-container *ngTemplateOutlet="offerCreatorsResponse"></ng-container>
            </mat-tab>
            <mat-tab [label]="'offers.plural.proposed.value' | translate" data-tag="proposedOffers">
                <ng-container *ngTemplateOutlet="proposedOffers"></ng-container>
            </mat-tab>
        }
    </mat-tab-group>

</form>

<ng-template #generalData>

    <ng-container [formGroup]="form">

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'tender.follow.mine.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        @if(userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine) {

                            <!-- Statut créateur d'offres -->

                            <div class="ligne_form row marges">

                                <div class="col_12 form-group">

                                    <div class="framed_green">

                                        <p class="read">
                                            <strong class="subtitle_green">{{ 'offerCreator.status.value' | translate }}</strong>
                                        </p>

                                        <br/>

                                        <div class="form-group">

                                            <div class="radio">
                                                <input type="radio" [value]="'reply'" formControlName="offerCreatorStatus" class="form-control" id="offerCreatorStatusReply">
                                                <label for="offerCreatorStatusReply">{{ 'status.reply.action.mine.value' | translate }}</label>
                                            </div>

                                            <div class="radio">
                                                <input type="radio" [value]="'no-reply'" formControlName="offerCreatorStatus" class="form-control" id="offerCreatorStatusNoReply">
                                                <label for="offerCreatorStatusNoReply">{{ 'status.no-reply.action.mine.value' | translate }}</label>
                                            </div>

                                            @if(form.get('offerCreatorStatus').value === 'reply') {
                                                <span class="message-help"><mat-icon>info</mat-icon>{{ 'tender.status.reply.help.value' | translate }}</span>
                                            }

                                            @if(form.get('offerCreatorStatus').value === 'no-reply') {
                                                <span class="message-help"><mat-icon>info</mat-icon>{{ 'tender.status.no-reply.help.value' | translate }}</span>
                                            }

                                        </div>

                                    </div>
                                </div>

                            </div>

                            @if(form.get('offerCreatorStatus').value === 'no-reply') {

                                <div class="ligne_form row marges">

                                    <div class="col_12">

                                        <div class="form-group">

                                            <div class="form-group">
                                                <textarea placeholder=" " class="form-control" formControlName="offerCreatorNoReplyReason" id="offerCreatorNoReplyReason"></textarea>
                                                <label for="offerCreatorNoReplyReason">{{ 'noReply.reason.value' | translate }}</label>
                                                @if(form.get('offerCreatorNoReplyReason').errors && (form.get('offerCreatorNoReplyReason').dirty || form.get('offerCreatorNoReplyReason').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(form.get('offerCreatorNoReplyReason').errors.isRequired) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                            @if(form.get('offerCreatorNoReplyReason').errors.maxLength) {
                                                                <div>{{ 'form.control.error.maxLength.value' | translate: { maxLength : maxLengthOfferCreatorRefusalReason } }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }

                            <!-- Collaborateur en charge de la demande -->

                            <div class="ligne_form row_marges">

                                <div class="col_12">

                                    <div class="form-group">

                                        <p class="read">
                                            <strong>{{ 'tender.offerCreator.responsibleUser.value' | translate }}</strong>
                                        </p>

                                        <div class="select_responsible">
                                            <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'offerCreatorResponsibleUser'"></app-core-select-search>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            @if(!!currentOfferCreatorResponsibleUser) {

                                <div class="ligne_form row_marges">

                                    <div class="col_12">

                                        <div class="bloc_recap">

                                            <div class="form-group">

                                                <!-- Nom -->

                                                @if(currentOfferCreatorResponsibleUser?.firstName || currentOfferCreatorResponsibleUser?.lastName) {

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.firstName }} {{ currentOfferCreatorResponsibleUser?.lastName }}
                                                    </p>
                                                }

                                                <!-- Service -->

                                                @if(currentOfferCreatorResponsibleUser?.service) {

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.service }}
                                                    </p>
                                                }

                                                <!-- Email -->

                                                @if(currentOfferCreatorResponsibleUser?.email) {

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.email }}
                                                    </p>
                                                }

                                                <!-- Téléphone -->

                                                @if(currentOfferCreatorResponsibleUser?.switchboardPhone) {

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.switchboardPhone }}
                                                    </p>
                                                }

                                                <!-- Adresse -->

                                                @if(currentOfferCreatorResponsibleUser?.address) {

                                                    <p class="read">
                                                        <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                                        {{ currentOfferCreatorResponsibleUser?.address.address }}, {{ currentOfferCreatorResponsibleUser?.address.zipcode }} {{ currentOfferCreatorResponsibleUser?.address.city }}
                                                    </p>
                                                }

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            }

                        }

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="form-group">

                                    <!-- N° de dossier -->

                                    <p class="read">
                                        <strong>{{ 'folder.numero.tywin.value' | translate }} : </strong>
                                        @if(tender.reference) {
                                            {{ tender.reference }}
                                        } @else {
                                            <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                        }
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">

                                    <!-- Date de la demande -->

                                    <p class="read">
                                        <strong>{{ 'request.date.value' | translate }} : </strong>
                                        {{ moment(tender.createdAt).format('dddd D MMMM YYYY') | titlecase }}
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_content y_items_center">
                                <div class="form-group">

                                    <!-- Date limite de réponse -->

                                    <p class="read">
                                        <strong>{{ 'response.date.limit.value' | translate }} : </strong>
                                        @if(!closedAtUpdateRequested) {
                                            <span>{{ moment(tender.closedAt).format('dddd D MMMM YYYY') | titlecase }}</span>
                                        }
                                    </p>
                                </div>

                            </div>

                            @if(updateClosedAtAllowed) {

                                <div class="col_content y_items_center">

                                    <div class="form-group little_margin">

                                        @if(!closedAtUpdateRequested && userService.hasAccess(currentUser, 'TENDER_CREATE')) {

                                            <div class="form-group">

                                                <!-- Prolonger la date limite -->

                                                <button class="btn_cta btn_little" type="button" (click)="closedAtUpdateRequested = true">
                                                    {{ 'date.limit.extend.action.value'|translate }}
                                                </button>

                                            </div>
                                        }

                                        @if(closedAtUpdateRequested) {

                                            <div class="form-group">

                                                <div class="form-group">
                                                    <input type="text" class="datetimepicker" matInput readonly [matDatepicker]="closedAtPicker" [min]="minClosedAt" [max]="maxClosedAt" formControlName="closedAt" (click)="closedAtPicker.open()" id="closedAt" placeholder=" ">
                                                    <label for="closedAt">{{ 'response.date.limit.value' | translate }}</label>
                                                    <mat-datepicker #closedAtPicker></mat-datepicker>
                                                    @if(form.get('closedAt').errors && (form.get('closedAt').dirty || form.get('closedAt').touched)) {
                                                        <mat-error>
                                                            <div class="invalid-feedback">
                                                                @if(form.get('closedAt').errors.required) {
                                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                }
                                                            </div>
                                                        </mat-error>
                                                    }
                                                </div>

                                            </div>
                                        }

                                    </div>

                                </div>
                            }

                        </div>

                        <!-- Statut demande de création d'offres -->

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">
                                    <p class="read">
                                        <strong>{{ 'tender.status.value' | translate }} : </strong>
                                        @if(!updateAllowed || !isMine) {
                                            {{ ('status.' + tender.status + '.value') | translate }}
                                        }
                                    </p>

                                </div>
                            </div>
                        </div>

                        @if(updateAllowed && isMine) {

                            <div class="ligne_form row marges">

                                <div class="col_6">

                                    <div class="form-group">

                                        <div class="radio">
                                            <input type="radio" [value]="'in-progress'" formControlName="status" class="form-control" id="statusInProgress">
                                            <label for="statusInProgress">{{ 'status.in-progress.value' | translate }}</label>
                                        </div>

                                        <div class="radio">
                                            <input type="radio" [value]="'cancelled'" formControlName="status" class="form-control" id="statusCancelled">
                                            <label for="statusCancelled">{{ 'status.cancelled.value' | translate }}</label>
                                        </div>

                                        <div class="radio">
                                            <input type="radio" [value]="'stopped'" formControlName="status" class="form-control" id="statusStopped">
                                            <label for="statusStopped">{{ 'status.stopped.value' | translate }}</label>
                                        </div>

                                        <div class="radio">
                                            <input type="radio" [value]="'expired'" [checked]="tender.status === 'expired'" [disabled]="true" class="form-control" id="statusExpired">
                                            <label for="statusExpired">{{ 'status.expired.value' | translate }}</label>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <div class="form-group">
                                        <span class="message-help"><mat-icon>info</mat-icon>{{ 'tender.status.help.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>

                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ (isMine ? 'coordinate.plural.mine.value' : 'transmitter.coordinate.value') | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <div class="ligne_form row_marges">

                            <div class="col_12">

                                <div class="bloc_recap">

                                    <div class="form-group">

                                        @if(userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine) {

                                            <!-- Nom de l'émetteur -->

                                            <p class="read">
                                                <strong>{{ 'transmitter.name.value' | translate }} : </strong>
                                                {{ tender.society.name }}
                                            </p>

                                            @if(currentTenderOfferCreator.status === 'reply') {

                                                <!-- Email de l'émetteur -->

                                                <p class="read">
                                                    <strong>{{ 'transmitter.email.value' | translate }} : </strong>
                                                    {{ tender.society.email }}
                                                </p>

                                                <!-- Téléphone de l'émetteur -->

                                                <p class="read">
                                                    <strong>{{ 'transmitter.phone.value' | translate }} : </strong>
                                                    @if(tender.society.phone) {
                                                        {{ tender.society.phone }}
                                                    } @else {
                                                        <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                    }
                                                </p>
                                            }

                                            <br>
                                        }

                                        @if(isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && !!currentResponsibleUser) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) {

                                            <p class="read">
                                                <strong class="subtitle_green">{{ 'request.collaborator.transmitter' | translate }}</strong>
                                            </p>

                                            @if(updateAllowed && isMine) {

                                                <div style="margin-top: 12px">
                                                    <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'responsibleUser'"></app-core-select-search>
                                                </div>

                                                @if(form.get('responsibleUser').invalid && (form.get('responsibleUser').dirty || form.get('responsibleUser').touched)) {

                                                    <mat-error>

                                                        <div class="invalid-feedback">

                                                            @if(form.get('responsibleUser').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }

                                                        </div>

                                                    </mat-error>
                                                }
                                            }
                                        }

                                    </div>

                                    @if(!!currentResponsibleUser) {

                                        <div class="form-group">

                                            <!-- Nom -->

                                            @if(currentResponsibleUser?.firstName || currentResponsibleUser?.lastName) {

                                                <p class="read">
                                                    <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.firstName }} {{ currentResponsibleUser?.lastName }}
                                                </p>
                                            }

                                            <!-- Service -->

                                            @if(currentResponsibleUser?.service) {

                                                <p class="read">
                                                    <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.service }}
                                                </p>
                                            }

                                            <!-- Email -->

                                            @if((isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentTenderOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.email) {

                                                <p class="read">
                                                    <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.email }}
                                                </p>
                                            }

                                            <!-- Téléphone -->

                                            @if((isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentTenderOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.switchboardPhone) {

                                                <p class="read">
                                                    <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.switchboardPhone }}
                                                </p>
                                            }

                                            <!-- Adresse -->

                                            @if((isMine || (userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine && (currentTenderOfferCreator.status === 'reply')) || userService.hasOneOfThisRoles(currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])) && currentResponsibleUser?.address) {

                                                <p class="read">
                                                    <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                                    {{ currentResponsibleUser?.address.address }}, {{ currentResponsibleUser?.address.zipcode }} {{ currentResponsibleUser?.address.city }}
                                                </p>
                                            }

                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

    </ng-container>

</ng-template>

<ng-template #tenderData>

    <ng-container [formGroup]="form">


        <!-- Créateurs d'offre sélectionnés -->

        <div class="form_part limited">

            <div class="page_title">
                <div class="row marges">
                    <div class="col_content y_items_center">
                        <button class="btn_cta btn_little" type="button" (click)="downloadTenderFile($event)">
                            {{ 'tender.download.value' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="bloc_recap lightgreen">

            <div class="ck-content">

                @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])) {

                    <p class="titre_h3 highlight">{{ 'offerCreator.plural.selected.value' | translate}}</p>

                    <ul>
                        @for(offerCreator of tender.offerCreators; track offerCreator) {
                            <li>{{ offerCreator.offerCreator.name }}</li>
                        }
                    </ul>

                    <br>
                }

                <p class="titre_h3 highlight">{{ (isMine ? 'purpose.request.mine.value' : 'purpose.request.value') | translate }}</p>

                <p>
                    @if(tender.purposeRequest) {
                        {{ tender.purposeRequest }}
                    } @else {
                        <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                    }
                </p>
            </div>

        </div>

        </div>

        <div class="form_part limited">
            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'generalData.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <div class="row marges ligne_form">

                            <!-- Cible de clientèle -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'customer.target.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.customerTypology) {
                                                {{ translationService.getFallbackTranslation(tender.configuration.customerTypology.translations).name }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Type de public -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'public.type.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.customerTypology) {
                                                {{ parsedPublics }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">

                            <!-- Nombre de participants -->

                            <div class="col_12" [ngClass]="{ 'col_md_6': tender.composition.publics.includes('child') }">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'participant.plural.count.value' | translate }}</p>
                                        <p>
                                            @if(tender.composition.publics.length) {
                                                {{ parsedParticipants }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Age des enfants -->

                            @if(tender.composition.publics.includes('child')) {

                                <div class="col_12 col_md_6">
                                    <div class="bloc_recap">
                                        <div class="ck-content">
                                            <p class="titre_h4 highlight">{{ 'child.plural.age.value' | translate }}</p>
                                            <p>
                                                @if(tender.composition.publics.includes('child')) {
                                                    {{ 'children.age.interval.value' | translate: { min: tender.composition.minChildrenAge, max: tender.composition.maxChildrenAge } }}
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'offer.content.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <!-- Durée du séjour -->

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'stay.duration.value' | translate }}</p>
                                        <p>
                                            @if(tender.composition.minDuration && tender.composition.maxDuration) {
                                                {{ 'stay.duration.interval.value' | translate:{ min: translationService.getFallbackTranslation(tender.composition.minDuration.translations).label, max: translationService.getFallbackTranslation(tender.composition.maxDuration.translations).label } }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Destinations -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'destination.plural.value' | translate }}</p>
                                        <p>
                                            @if(regions.length) {
                                                {{ parseAttributes(regions) }}
                                            } @else {
                                                {{ 'france.all.value' | translate }}
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Commentaire destination -->

                            <div class="col_12 col_md_6">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.destination.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.destinationsComment) {
                                                {{ tender.configuration.destinationsComment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <!-- Types de séjour -->

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'stay.plural.type.plural.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.types.length) {
                                                {{ parseAttributes(tender.configuration.types) }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Thématiques -->

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'offer.list.filter.themes.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.themes.length) {
                                                {{ parseAttributes(tender.configuration.themes) }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Hébergements -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'accommodation.type.plural.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.accommodations.length) {
                                                {{ parseAttributes(tender.configuration.accommodations) }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Commentaire hébergement (type de chambre, niveau de confort, situation…) -->

                            <div class="col_12 col_md_6">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.accommodation.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.accommodationsComment) {
                                                {{ tender.configuration.accommodationsComment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Restauration -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'restoration.type.plural.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.restorations.length) {
                                                {{ parseAttributes(tender.configuration.restorations) }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Commentaire restauration -->

                            <div class="col_12 col_md_6">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.restoration.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.restorationsComment) {
                                                {{ tender.configuration.restorationsComment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <!-- Activités payantes souhaitées -->

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'activity.plural.payable.wish.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.activities.length) {
                                                {{ parseAttributes(tender.configuration.activities) }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Langues de l'offre -->

                        <div class="row marges ligne_form">

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'offer.language.plural.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.locales.length) {
                                                {{ parsedLocales }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Commentaire sur le transport -->

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.stay.transportComment.value' | translate }} {{ 'tender.transport.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.transportComment) {
                                                {{ tender.configuration.transportComment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <!-- Commentaire sur le séjour -->

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.stay.comment.value' | translate }} {{ 'tender.offer.content.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.configuration.contentOfferComment) {
                                                {{ tender.configuration.contentOfferComment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'marketing.param.plural.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>

                        <div class="row marges ligne_form">

                            <!-- Modes de commercialisation -->

                            <div class="col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.marketing.mode.plural.value' | translate }}</p>
                                        <p>{{ parsedMarketingModes }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Devise -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'currency.value' | translate }}</p>
                                        <p>
                                            @if(tender.pricing.currency) {
                                                {{ translationService.getFallbackTranslation(tender.pricing.currency.translations).label }} ({{ tender.pricing.currency.symbol }})
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Commentaire commercialisation -->

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.marketing.comment.value' | translate }}</p>
                                        <p>
                                            @if(tender.pricing.comment) {
                                                {{ tender.pricing.comment }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Type de tarif -->

                            @if(tender.pricing.allowOnlineSale || tender.pricing.allowBooking) {

                                <div class="col_12" [ngClass]="{ 'col_md_4': tender.pricing.allowGiftVoucher, 'col_md_6': !tender.pricing.allowGiftVoucher }">
                                    <div class="bloc_recap">
                                        <div class="ck-content">
                                            <p class="titre_h4 highlight">{{ 'price.type.value' | translate }}</p>
                                            <p>
                                                @if(tender.pricing.priceType) {
                                                    {{ ('price.' + tender.pricing.priceType.toLowerCase() + '.value') | translate }}
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }

                            <!-- Tarif -->

                            @if(tender.pricing.allowOnlineSale || tender.pricing.allowBooking) {

                                <div class="col_12" [ngClass]="{ 'col_md_4': tender.pricing.allowGiftVoucher, 'col_md_6': !tender.pricing.allowGiftVoucher }">
                                    <div class="bloc_recap">
                                        <div class="ck-content">
                                            @if(userService.hasRole(currentUser, 'ROLE_OFFER_DISTRIBUTOR')) {
                                                <p class="titre_h4 highlight">{{ 'price.plural.net.desired.value' | translate }}</p>
                                            }
                                            @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {
                                                <p class="titre_h4 highlight">{{ 'price.plural.public.desired.value' | translate }}</p>
                                            }
                                            @if(userService.hasRole(currentUser, 'ROLE_OFFER_CREATOR') && !isMine) {
                                                <p class="titre_h4 highlight">{{ 'price.value' | translate }}</p>
                                            }
                                            <p>
                                                @if(tender.pricing.currency) {
                                                    {{ parsedPrices }}
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }

                            <!-- Tarif bon cadeau -->

                            @if(tender.pricing.allowGiftVoucher) {

                                <div class="col_12 col_md_4">
                                    <div class="bloc_recap">
                                        <div class="ck-content">
                                            <p class="titre_h4 highlight">{{ 'giftVoucher.price.plural.ttc.desired.value' | translate }}</p>
                                            <p>
                                                @if(tender.pricing.currency) {
                                                    {{ parsedGifVoucherPrices }}
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'stay.interval.plural.value' | translate }}</p>
                                        @if(tender.composition.dates.length) {
                                            @for(item of tender.composition.dates; track item) {
                                                <p>
                                                    @if(item.dateEnd) {
                                                        {{ 'date.interval.value' | translate:{ dateStart: moment(item.dateStart).format('L'), dateEnd: moment(item.dateEnd).format('L') } }}
                                                    } @else {
                                                        {{ moment(item.dateStart).format('L') }}
                                                    }
                                                </p>
                                            }
                                        } @else {
                                            <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'assurance.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <div class="row marges ligne_form">

                            <!-- Assurance -->

                            <div class="col_12" [ngClass]="{ 'col_md_6': tender.configuration.hasInsurance }">

                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.insurance.travel.value' | translate }}</p>
                                        <p>{{ (tender.configuration.hasInsurance ? 'yes.value' : 'no.value') | translate }}</p>
                                    </div>
                                </div>

                            </div>

                            <!-- Type assurance -->

                            @if(tender.configuration.hasInsurance) {

                                <div class="col_12 col_md_6">

                                    <div class="bloc_recap">
                                        <div class="ck-content">
                                            <p class="titre_h4 highlight">{{ 'insurance.type.value' | translate }}</p>
                                            <p>
                                                @if(tender.configuration.hasInsurance) {
                                                    {{ tender.configuration.insuranceComment }}
                                                } @else {
                                                    <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                }
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            }

                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="form_part limited">

            <mat-accordion class="gradient">
                <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ 'tender.mine.param.plural.value' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>

                        <div class="row marges ligne_form">

                            <!-- Référence interne -->

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'reference.value' | translate }}</p>
                                        <p>
                                            @if(tender.ownerReference) {
                                                {{ tender.ownerReference }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Date limite de réponse -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'response.date.limit.value' | translate }}</p>
                                        <p>
                                            @if(tender.closedAt) {
                                                {{ moment(tender.closedAt).format('L') }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Date de début de commercialisation de l'offre -->

                            <div class="col_12 col_md_6">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'tender.marketing.date.start.value' | translate }}</p>
                                        <p>
                                            @if(tender.marketingDateStart) {
                                                {{ moment(tender.marketingDateStart).format('L') }}
                                            } @else {
                                                <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <!-- Documents à joindre -->

                            <div class="col_12">
                                <div class="bloc_recap">
                                    <div class="ck-content">
                                        <p class="titre_h4 highlight">{{ 'document.plural.attachment.value' | translate }}</p>
                                        @if(tender.documents.length) {
                                            @for(document of tender.documents; track document) {
                                                <p class="cliquable_file" (click)="downloadDocument(document)">
                                                    {{ document.file?.name }}
                                                </p>
                                            }
                                        } @else {
                                            <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="bloc_recap">

                                    <div class="row marges ligne_form">
                                        <div class="col_12">

                                            <!-- Commentaire pour le créateur d'offres -->

                                            <div class="ck-content">
                                                <p class="titre_h4 highlight">{{ 'tender.offerCreator.comment.value' | translate }}</p>
                                                <p>
                                                    @if(!offerCreatorCommentUpdateRequested) {
                                                        @if(tender.comment) {
                                                            @if(!offerCreatorCommentUpdateRequested) {
                                                                <span>{{ tender.comment }}</span>
                                                            }
                                                        } @else {
                                                            <ng-container *ngTemplateOutlet="uninformed"></ng-container>
                                                        }
                                                    }
                                                </p>
                                            </div>

                                        </div>
                                    </div>

                                    @if(updateAllowed && isMine) {

                                        <div class="row marges ligne_form little_margin">
                                            <div class="col_12">

                                                @if(!offerCreatorCommentUpdateRequested) {

                                                    <div>

                                                        <!-- Modification du champ commentaire pour le créateur d'offre -->

                                                        <button class="btn_cta btn_little" type="button" (click)="offerCreatorCommentUpdateRequested = true">
                                                            {{ 'comment.update.action.value'|translate }}
                                                        </button>

                                                    </div>

                                                } @else {

                                                    <div>

                                                        <div class="form-group">
                                                            <textarea placeholder=" " class="form-control" formControlName="comment" id="comment"></textarea>
                                                            <label for="comment">{{ 'tender.offerCreator.comment.value' | translate }}</label>
                                                        </div>

                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    }

                                </div>

                            </div>

                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

    </ng-container>

</ng-template>

<ng-template #offersSelection>

    <ng-container [formGroup]="form">

        <div class="row marges ligne_form" style="margin-bottom: 24px;">
            <div class="col_12">
                <div class="form-group">
                    <span class="message-help"><mat-icon>info</mat-icon>{{ 'tender.offer.selection.description.value' | translate:{ transmitter: tender.society.name } }}</span>
                </div>
            </div>
        </div>

        <div [formGroup]="form" class="tab_content_overflow">

            <div class="row marges">

                <div class="col y_items_center">

                    @if(offerSearchService.selectedOffers.value.length) {

                        <div class="selected_offers">

                            <span>{{ 'offer.list.selected.value' | translate }} :</span>

                            <ul>
                                @for(offer of offerSearchService.selectedOffers.value; track offer) {
                                    <li>{{ translationService.getFallbackTranslation(offer.translations).name }}<mat-icon (click)="unselectOffer(offer)">close</mat-icon></li>
                                }
                            </ul>

                        </div>
                    }
                </div>

                @if(offerSearchService.selectedOffers.value.length) {

                    <div class="col_content y_items_center">
                        <button type="button" class="btn_cta btn_little" (click)="resetOfferSelection() ">{{ 'offer.list.selection.reset.action.value' | translate}}</button>
                    </div>
                }

            </div>

            <app-core-offer-search
                [user]="currentUser"
                [society]="currentUser.society"
                [mode]="'tender-personnal-offers'"
                [loadItemsSourceCallback]="loadOffersSourceCallback"
            ></app-core-offer-search>

        </div>

    </ng-container>

</ng-template>

<ng-template #offerCreatorsSelection>

    <ng-container [formGroup]="form">

        <div class="tab_content_overflow">

            <!-- Créateurs d'offres sélectionnés -->

            @if(offerCreatorSearchService.selectedOfferCreators$.value.length) {

                <div class="row marges">

                    <div class="col y_items_center">

                        <div class="selected_offers">

                            <span>{{ 'offerCreator.list.selected.value' | translate }} :</span>

                            <ul>
                                @for(offerCreator of offerCreatorSearchService.selectedOfferCreators$.value; track offerCreator) {
                                    <li>
                                        {{ offerCreator.name }}@if(!isTenderAlreadyReceivedByOfferCreator(offerCreator)) {<mat-icon (click)="offerCreatorSearchService.unselectOfferCreator(offerCreator)">close</mat-icon>}
                                    </li>
                                }
                            </ul>
                        </div>

                    </div>

                </div>
            }

            <!-- Liste des créateurs d'offres -->

            @if(isCurrentTabTag('offerCreatorsSelection') && userService.hasAccess(currentUser, 'OFFER_CREATOR_LIST')) {

                <app-core-offer-creator-search [mode]="'tender'"
                                               [loadItemsSourceCallback]="loadItemsSourceCallback('offerCreatorsSelection')"
                ></app-core-offer-creator-search>
            }

        </div>

    </ng-container>

</ng-template>

<ng-template #offerCreatorsResponse>

    <ng-container [formGroup]="form">

        <div class="tab_content_overflow">

            <!-- Liste des créateurs d'offres -->

            @if(isCurrentTabTag('offerCreatorsResponse')) {

                <app-core-offer-creator-search [mode]="'tender'"
                                               [loadItemsSourceCallback]="loadItemsSourceCallback('offerCreatorsResponse')"
                ></app-core-offer-creator-search>
            }

        </div>

    </ng-container>

</ng-template>

<ng-template #proposedOffers>

    <ng-container [formGroup]="form">

        <div class="tab_content_overflow">

            <!-- Gestion de la vue active -->

            @switch (true) {

                <!-- Moteur de recherche -->

                @case (isCurrentProposalOfferView('search-engine')) {
                    <ng-container *ngTemplateOutlet="proposalOfferSearchEngine"></ng-container>
                }

                <!-- Visualisation d'une offre -->

                @case (isCurrentProposalOfferView('offer-item')) {
                    <ng-container *ngTemplateOutlet="proposalOfferItem"></ng-container>
                }
            }

        </div>

        <ng-template #proposalOfferSearchEngine>

            <app-core-offer-search
                [user]="currentUser"
                [society]="currentUser.society"
                [mode]="'tender-proposed-offers'"
                [loadItemsSourceCallback]="loadProposedOffersSourceCallback"
            ></app-core-offer-search>

        </ng-template>

        <ng-template #proposalOfferItem>

            @if((currentProposedOffer$ | async); as currentProposedOffer) {

                @if(currentProposedOffer) {

                    <div class="page_offer">

                        <!-- Actions -->

                        <div class="back_to_list page_title">

                            <div class="col_12 y_items_center">

                                <!-- Retour à la liste -->

                                <div class="col_6">
                                    <span class="ty-chevron" (click)="setCurrentProposalOfferView('search-engine')">{{ 'tender.offer.list.back.value' | translate }}</span>
                                </div>

                                @if(!offerCatalogService.getSelfItemByOffer(currentProposedOffer)) {

                                    <div class="col_6 x_end">

                                        <!-- Ajouter à mon catalogue -->

                                        <button class="btn_cta btn_small btn_add" type="button" (click)="addOfferToCatalog(currentProposedOffer)">
                                            {{ 'offer.list.item.action.catalog.add.value' | translate }}
                                        </button>

                                        <!-- Refuser l'offre -->

                                        <button class="btn_cta btn_small btn_lines margin" type="button" (click)="openRefuseOfferDialog(currentProposedOffer)">
                                            {{ 'tender.offer.refused.value' | translate }}
                                        </button>
                                    </div>
                                }

                            </div>
                        </div>

                        <!-- Commentaire du créateur d'offres -->

                        @if(getTenderOfferCreatorOfferFromOffer(currentProposedOffer).comment) {

                            <mat-accordion class="gradient" >
                                <mat-expansion-panel [expanded]="false">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>{{ 'tender.comment.fromOfferCreator.value' | translate }}</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="col_12 txt_offer">
                                        <div class="description_offer ck-content">
                                            <p>{{ getTenderOfferCreatorOfferFromOffer(currentProposedOffer).comment }}</p>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        }

                        <!-- Caractéristiques de l'offre -->

                        <mat-accordion class="gradient">
                            <mat-expansion-panel [expanded]="false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{ 'tender.offer.item.details.value' | translate }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                    <app-core-offer-item-detail [item]="currentProposedOffer"></app-core-offer-item-detail>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>

                        <!-- Contenu de l'offre -->

                        <mat-accordion class="gradient">
                            <mat-expansion-panel [expanded]="true">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{ 'tender.offer.item.value' | translate }}</mat-panel-title>
                                </mat-expansion-panel-header>

                                <div>
                                    <app-core-offer-item [isMine]="isMine" [roles]= "currentUser.roles" [item]="currentProposedOffer" [configuration]="offerDetailConfiguration">

                                        <!-- Projection de contenu pour la composition -->

                                        <div compositionContent>
                                            <ng-container *ngTemplateOutlet="dateEngineTemplate"></ng-container>
                                        </div>

                                    </app-core-offer-item>
                                </div>

                            </mat-expansion-panel>
                        </mat-accordion>

                    </div>
                }
            }

        </ng-template>

    </ng-container>

</ng-template>

<ng-template #uninformed>{{ 'uninformed.value' | translate }}</ng-template>

<ng-template #withoutPreference>{{ 'withoutPreference.value' | translate }}</ng-template>

<ng-template #dateEngineTemplate>

    @if((currentProposedOffer$ | async); as currentProposedOffer) {

        @if(currentProposedOffer) {

            <div class="choice_date">

                <!-- Moteur de date -->

                <div class="row marges">

                    <div class="col_12">
                        <app-core-offer-date-engine [childDatesAllowed]="childDatesOffer(currentProposedOffer)" [currentUser]="currentUser" [offer]="currentProposedOffer" [configuration]="offerDateEngineConfiguration" [loadItemsSourceCallback]="loadOfferAvailabilityItemsSourceCallback" [loadFirstAvailabilityItemSourceCallback]="loadOfferFirstAvailabilityItemSourceCallback"></app-core-offer-date-engine>
                    </div>

                </div>

                <div class="row x_end validate_date">

                    @if(hasGiftVoucherEnable(currentProposedOffer)) {
                        <!-- Bon cadeau -->

                        <button type="button" class="btn_cta btn_lines btn_little" [disabled]="true">
                            {{ 'offer.gift.value' | translate }}
                        </button>
                    }

                    <!-- Demande de réservation -->

                    <button type="button" class="btn_cta btn_little btn_booking" [disabled]="true">
                        {{ bookingRequestLabel }}
                    </button>

                    @if(currentProposedOffer.isAllowBookingRequest) {

                        <!-- Demande de devis -->

                        <button type="button" class="btn_cta btn_little btn_booking" [disabled]="true">
                            {{ quotationRequestLabel }}
                        </button>
                    }

                </div>

            </div>
        }
    }

</ng-template>
